<template>
  <div>
    <v-form v-model="valid" ref="form">
      <v-text-field v-model="value.status" :label="$t('entities.environment.jobStatus.props.status')" :rules="$isRequiredRule"></v-text-field>
      <v-text-field v-model="value.seq" :label="$t('entities.environment.jobStatus.props.seq')" :rules="$isRequiredRule"></v-text-field>
      <v-text-field v-model="value.description" :label="$t('entities.environment.jobStatus.props.description')" :rules="$isRequiredRule"></v-text-field>
      <color-dialog v-model="value.color" :label="$t('entities.environment.jobStatus.props.color')"></color-dialog>
      <v-select
        v-model="value.statusNext"
        :items="status"
        attach
        chips
        :label="$t('entities.environment.jobStatus.props.statusNext')"
        multiple
      ></v-select>
         <v-text-field v-model="value.leadTimeMin" :label="$t('entities.environment.jobStatus.props.leadTimeMin')" type="number"></v-text-field>
    </v-form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: () => {
        return {
          seq: 0,
          status: "",
          description: "",
          color: "",
          statusNext: []
        };
      }
    },
    status: {
      type: Array
    }
  },
  data() {
    return {
      valid:true,
      openColor: false,
      color: {}
    };
  },
  watch: {
    value() {
      this.$refs.form.resetValidation()
      this.color.hex = this.value.color;
    },
    color() {
      this.value.color = this.color.hex;
    }
  },
  methods: {
    isValid(){
      return this.$refs.form.validate();
    },
    clickColor() {
      this.openColor = !this.openColor;
    }
  }
};
</script>